import React from 'react';
import { RefreshControl, ScrollView, View } from 'react-native';
import { useQuery } from '@tanstack/react-query';
import { SafeAreaView } from 'react-native-safe-area-context';

import api from '../../../utils/api';
import tw from '../../../styles/tailwind';
import Text from '../../../components/Text';

type DashboardData = {
  communities: { count: number; deleted_count: number };
  users: { count: number };
  residents: { count: number; deleted_count: number };
  fee_payments_month: { count: number; amount: number };
  control_panels: { total: number; alive: number };
};

function Card({ title, value, hint }: { title: string; value: string | number; hint?: string }) {
  return (
    <View style={tw`bg-white rounded-lg p-4 mb-3 shadow-sm`}>
      <Text style={tw`text-gray-500 text-sm`}>{title}</Text>
      <Text style={tw`text-2xl font-600 text-gray-800`}>{value}</Text>
      {hint ? <Text style={tw`text-gray-400 text-xs mt-1`}>{hint}</Text> : null}
    </View>
  );
}

export default function DashboardScreen() {
  const { data, isLoading, refetch } = useQuery<DashboardData>({
    queryKey: ['meta.dashboard'],
    queryFn: () => api.get('/admin/dashboard').then(r => r.data),
  });

  return (
    <SafeAreaView style={tw`flex-1 bg-background`}>
      <ScrollView
        contentContainerStyle={tw`p-4`}
        refreshControl={<RefreshControl onRefresh={refetch} refreshing={isLoading} />}
      >
        <Text style={tw`text-xl font-600 text-gray-800 mb-3`}>Meta Admin</Text>

        <Card
          title="Fraccionamientos"
          value={data?.communities.count ?? '—'}
          hint={data ? `${data.communities.deleted_count} eliminados` : undefined}
        />
        <Card title="Usuarios" value={data?.users.count ?? '—'} />
        <Card
          title="Residentes"
          value={data?.residents.count ?? '—'}
          hint={data ? `${data.residents.deleted_count} eliminados` : undefined}
        />
        <Card
          title="Pagos este mes"
          value={data ? `$${data.fee_payments_month.amount.toLocaleString()}` : '—'}
          hint={data ? `${data.fee_payments_month.count} pagos` : undefined}
        />
        <Card
          title="Paneles de control"
          value={data ? `${data.control_panels.alive} / ${data.control_panels.total} en línea` : '—'}
        />
      </ScrollView>
    </SafeAreaView>
  );
}
